import { Box, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { vehicleModelDialogStyleProps } from "../theme/main";
import type { VehicleModelInfoBox } from "./VehicleModelTemplate";

type VehicleModelDialogProps = {
  infoBox?: VehicleModelInfoBox;
  open: boolean;
  onClose: () => void;
};

export function VehicleModelDialog({
  infoBox,
  open,
  onClose,
}: VehicleModelDialogProps) {
  const {
    dialogPaperStyle,
    dialogTitleStyle,
    dialogListStyle,
    dialogListItemStyle,
  } = vehicleModelDialogStyleProps;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: dialogPaperStyle,
        },
      }}
    >
      {infoBox && (
        <>
          <DialogTitle sx={dialogTitleStyle}>{infoBox.title}</DialogTitle>
          <DialogContent>
            <Box component="ul" sx={dialogListStyle}>
              {infoBox.points.map((point) => (
                <Typography key={point} component="li" sx={dialogListItemStyle}>
                  {point}
                </Typography>
              ))}
            </Box>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}
